// extracted by mini-css-extract-plugin
module.exports = {"select":"CarForm_select__m1bcr","dropzoneSection":"CarForm_dropzoneSection__2siWg"};